import React from 'react'
import { Grid, Container, Typography, CircularProgress, useTheme, useMediaQuery } from '@material-ui/core'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'
import { Link, useLocation } from 'react-router-dom'
import { useStore } from '../../context/Context'
import useStyles from './styles'

import CardGames from './CardGames/CardGames'

const ListGames = () => {
  const classes = useStyles()
  const location = useLocation()
  const theme = useTheme()
  const matchSM = useMediaQuery(theme.breakpoints.down('sm'))
  const { listGames, isLoading, setSelectedTab, isLogin } = useStore()
  const gamesEndpoint = location.pathname === '/games'
  const listGamesMap = gamesEndpoint ? listGames : isLogin ? listGames.slice(0, 6) : listGames.slice(0, 4)

  if (isLoading) return (
    <Grid container justifyContent="center" alignItems="center" className={classes.loading}>
      <CircularProgress />
    </Grid>
  )

  return (
    <main className={classes.root}>
      <Container>
        <Grid container direction="column">
          <Grid item container justifyContent="space-between" alignItems="center">
            <Grid item container={gamesEndpoint && matchSM} justifyContent={gamesEndpoint && matchSM ? 'center' : undefined}>
              <Grid item>
                <Typography variant="h5" color="textSecondary" className={classes.title}>{gamesEndpoint ? 'Games List' : 'Latest Games'}</Typography>
              </Grid>
            </Grid>
            {(listGames.length > 4 && location.pathname !== '/games') && (
              <Grid item>
                <Grid item container alignItems="center" component={Link} to="#" className={classes.link}>
                  <Typography variant="caption" onClick={() => window.location.href = '/games'}>View More</Typography>
                  <ChevronRightIcon />
                </Grid>
              </Grid>
            )}
          </Grid>
          <Grid item container className={classes.cardContainer} justifyContent={matchSM ? 'center' : 'flex-start'} spacing={3}>
            {listGamesMap.map(game => (
              <Grid item key={game.id}>
                <CardGames
                  title={game.name}
                  year={game.release}
                  media={game.image_url}
                  genre={game.genre}
                  singleplayer={game.singlePlayer}
                  multiplayer={game.multiplayer}
                  platform={game.platform}
                  onClick={() => {
                    setSelectedTab(false)
                    window.location.href = "/showGame/" + game.id
                  }}
                />
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Container>
    </main>
  )
}

export default ListGames
